import Handler from "./../Handler";

class RefreshTableListViewAckHandler extends Handler {
    // "tableListViewA#":  {
    // "roomId":123,
    // "tableListViewDetailsList" :[
    //     {
    //     "tableId": "TBL001",
    //     "gameDefId": 201,
    //     "minimumBuyIn": 100.0,
    //     "maximumBuyIn": 500.0,
    //     "averageChipsStack": 250.0,
    //     "seatedPlayerCount": 3,
    //     "maximumPlayers": 6,
    //     "waitListCount": 1,
    //     "seatedPlayerDetails": {
    //         "player1": {
    //         "playerName": "Alice",
    //         "profileImageUrl": "https://example.com/images/alice.png",
    //         "atTableChips": 200.0,
    //         "position": 1,
    //         "positionName": "Dealer"
    //         },
    //         "player2": {
    //         "playerName": "Bob",
    //         "profileImageUrl": "https://example.com/images/bob.png",
    //         "atTableChips": 300.0,
    //         "position": 2,
    //         "positionName": "Small Blind"
    //         },
    //         "player3": {
    //         "playerName": "Carol",
    //         "profileImageUrl": "https://example.com/images/carol.png",
    //         "atTableChips": 250.0,
    //         "position": 3,
    //         "positionName": "Big Blind"
    //         }
    //     },
    //     "totalGamesDurationInHours": 5.5,
    //     "totalGamesOnTable": 22,
    //     "averageGamesPerHour": 4,
    //     "flopsSeenOnTable": 60,
    //     "potValueOnTable": 1200.0,
    //     "flopsSeenPercent": 68.2,
    //     "averagePotValue": 54.5
    //     },
    // ]
    // }
  execute(data) {
    let receivedData = JSON.parse(data);
    console.log("Refresh TableListViewAckHandler received data:", receivedData);
    this.service.processTableListViewProtocol(receivedData);
  }
}

export default RefreshTableListViewAckHandler;